(function() {
  "use strict";

  function buildRequestBody(params) {
    return new URLSearchParams(params).toString();
  }

  function parseMakeModelMap(raw) {
    var map = {};
    if (!raw) return map;
    raw.split(/\r?\n/).forEach(function(line) {
      var row = (line || "").trim();
      if (!row) return;
      var separatorIndex = row.indexOf(":");
      if (separatorIndex === -1) return;
      var make = row.slice(0, separatorIndex).trim();
      var modelsRaw = row.slice(separatorIndex + 1).trim();
      if (!make || !modelsRaw) return;
      var models = modelsRaw.split(",").map(function(item) {
        return item.trim();
      }).filter(Boolean);
      if (!models.length) return;
      map[make.toLowerCase()] = models;
    });
    return map;
  }

  function getClosestCard(target) {
    return target.closest("[data-wheel-card]");
  }

  function setSelectedCard(section, card) {
    if (!card) return;
    var cards = section.querySelectorAll("[data-wheel-card]");
    cards.forEach(function(item) {
      item.classList.toggle("is-selected", item === card);
    });

    var selectedBrand = section.querySelector("[data-selected-brand]");
    var selectedModel = section.querySelector("[data-selected-model]");
    var selectedType = section.querySelector("[data-selected-type]");
    var selectedPart = section.querySelector("[data-selected-part]");
    var brandValue = card.dataset.modelBrand || "";
    var modelValue = card.dataset.modelName || "";
    var typeValue = card.dataset.modelType || "";
    var partValue = card.dataset.modelPart || "";
    if (selectedBrand) selectedBrand.value = brandValue;
    if (selectedModel) selectedModel.value = modelValue;
    if (selectedType) selectedType.value = typeValue;
    if (selectedPart) selectedPart.value = partValue;

    var selectedSummary = section.querySelector("[data-selected-summary]");
    if (selectedSummary) {
      selectedSummary.textContent = (brandValue + " " + modelValue).trim() || "Wheel model";
    }

    var selectedPartRow = section.querySelector("[data-selected-part-row]");
    var selectedPartText = section.querySelector("[data-selected-part-text]");
    if (selectedPartRow && selectedPartText) {
      selectedPartText.textContent = partValue;
      selectedPartRow.hidden = !partValue;
    }

    var selectedMediaRow = section.querySelector("[data-selected-media-row]");
    var selectedImage = section.querySelector("[data-selected-image]");
    if (selectedMediaRow && selectedImage) {
      var imageValue = card.dataset.modelImage || "";
      var imageAlt = card.dataset.modelImageAlt || modelValue || "Wheel model";
      if (imageValue) {
        selectedImage.src = imageValue;
        selectedImage.alt = imageAlt;
        selectedMediaRow.hidden = false;
      } else {
        selectedMediaRow.hidden = true;
      }
    }
  }

  function setActiveBrand(section, brandKey) {
    var tabs = section.querySelectorAll("[data-wheel-brand-tab]");
    var cards = section.querySelectorAll("[data-wheel-card]");
    var track = section.querySelector("[data-wheel-track]");

    tabs.forEach(function(tab) {
      var active = tab.dataset.brand === brandKey;
      tab.classList.toggle("is-active", active);
      tab.setAttribute("aria-selected", active ? "true" : "false");
    });

    var firstVisible = null;
    cards.forEach(function(card) {
      var visible = card.dataset.brand === brandKey;
      card.hidden = !visible;
      if (visible && !firstVisible) firstVisible = card;
    });

    if (firstVisible) {
      setSelectedCard(section, firstVisible);
    }
    if (track) {
      track.scrollLeft = 0;
    }
    syncArrows(section);
    renderDots(section);
    syncDots(section);
  }

  function getCarouselPageCount(track) {
    if (!track) return 0;
    var pageWidth = Math.max(1, track.clientWidth);
    var pages = Math.ceil(track.scrollWidth / pageWidth);
    return Math.max(1, pages);
  }

  function renderDots(section) {
    var track = section.querySelector("[data-wheel-track]");
    var dotsWrap = section.querySelector("[data-wheel-dots]");
    if (!track || !dotsWrap) return;

    var pageCount = getCarouselPageCount(track);
    dotsWrap.innerHTML = "";

    if (pageCount <= 1) {
      dotsWrap.hidden = true;
      return;
    }

    dotsWrap.hidden = false;
    for (var i = 0; i < pageCount; i++) {
      var dot = document.createElement("span");
      dot.className = "wheel-explorer__dot";
      if (i === 0) dot.classList.add("is-active");
      dotsWrap.appendChild(dot);
    }
  }

  function syncDots(section) {
    var track = section.querySelector("[data-wheel-track]");
    var dotsWrap = section.querySelector("[data-wheel-dots]");
    if (!track || !dotsWrap || dotsWrap.hidden) return;

    var dots = dotsWrap.querySelectorAll(".wheel-explorer__dot");
    if (!dots.length) return;

    var pageWidth = Math.max(1, track.clientWidth);
    var pageIndex = Math.round(track.scrollLeft / pageWidth);
    if (pageIndex < 0) pageIndex = 0;
    if (pageIndex > dots.length - 1) pageIndex = dots.length - 1;

    dots.forEach(function(dot, idx) {
      dot.classList.toggle("is-active", idx === pageIndex);
    });
  }

  function syncArrows(section) {
    var track = section.querySelector("[data-wheel-track]");
    var prev = section.querySelector("[data-wheel-prev]");
    var next = section.querySelector("[data-wheel-next]");
    if (!track || !prev || !next) return;

    prev.disabled = track.scrollLeft <= 1;
    next.disabled = (track.scrollLeft + track.clientWidth) >= (track.scrollWidth - 1);
  }

  function attachCarousel(section) {
    var track = section.querySelector("[data-wheel-track]");
    var prev = section.querySelector("[data-wheel-prev]");
    var next = section.querySelector("[data-wheel-next]");
    if (!track || !prev || !next) return;

    function scrollByStep(direction) {
      var step = Math.max(220, Math.round(track.clientWidth * 0.78));
      track.scrollBy({ left: direction * step, behavior: "smooth" });
    }

    prev.addEventListener("click", function() { scrollByStep(-1); });
    next.addEventListener("click", function() { scrollByStep(1); });
    track.addEventListener("scroll", function() {
      syncArrows(section);
      syncDots(section);
    }, { passive: true });
    window.addEventListener("resize", function() {
      syncArrows(section);
      renderDots(section);
      syncDots(section);
    });
    track.querySelectorAll("img").forEach(function(image) {
      image.addEventListener("load", function() {
        syncArrows(section);
        renderDots(section);
        syncDots(section);
      });
    });
    renderDots(section);
    syncDots(section);
    syncArrows(section);
  }

  function attachSelection(section) {
    section.addEventListener("click", function(event) {
      var tab = event.target.closest("[data-wheel-brand-tab]");
      if (tab) {
        setActiveBrand(section, tab.dataset.brand || "");
        return;
      }

      var cardTrigger = event.target.closest("[data-wheel-select]");
      if (cardTrigger) {
        var card = getClosestCard(cardTrigger);
        setSelectedCard(section, card);
      }
    });
  }

  function attachBrandTabsScroller(section) {
    var tabs = section.querySelector(".wheel-explorer__brand-tabs");
    if (!tabs) return;
    var shared = window.PrinceExplorers;
    if (!shared || typeof shared.attachScrollableTabsWithFade !== "function") return;
    shared.attachScrollableTabsWithFade(tabs);
  }

  function setModalState(section, isOpen) {
    var modal = section.querySelector("[data-wheel-modal]");
    if (!modal) return;

    modal.hidden = !isOpen;
    modal.setAttribute("aria-hidden", isOpen ? "false" : "true");
    document.documentElement.classList.toggle("wheel-explorer-modal-open", isOpen);

    if (isOpen) {
      var nameField = modal.querySelector("[data-field-name]");
      if (nameField) nameField.focus();
    }
  }

  function setVehiclePanelState(section, isOpen) {
    var toggle = section.querySelector("[data-vehicle-toggle]");
    var panel = section.querySelector("[data-vehicle-panel]");
    if (!toggle || !panel) return;

    toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    panel.classList.toggle("is-open", isOpen);
  }

  function setContactPanelState(section, isOpen) {
    var toggle = section.querySelector("[data-contact-toggle]");
    var panel = section.querySelector("[data-contact-panel]");
    if (!toggle || !panel) return;

    toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    panel.classList.toggle("is-open", isOpen);
  }

  function attachVehicleAccordion(section) {
    var toggle = section.querySelector("[data-vehicle-toggle]");
    if (!toggle) return;

    setVehiclePanelState(section, false);
    toggle.addEventListener("click", function() {
      var expanded = toggle.getAttribute("aria-expanded") === "true";
      setVehiclePanelState(section, !expanded);
    });
  }

  function attachContactAccordion(section) {
    var toggle = section.querySelector("[data-contact-toggle]");
    if (!toggle) return;

    setContactPanelState(section, true);
    toggle.addEventListener("click", function() {
      var expanded = toggle.getAttribute("aria-expanded") === "true";
      setContactPanelState(section, !expanded);
    });
  }

  function replaceDatalistOptions(listElement, values) {
    if (!listElement) return;
    listElement.innerHTML = "";
    values.forEach(function(value) {
      var option = document.createElement("option");
      option.value = value;
      listElement.appendChild(option);
    });
  }

  function updateModelOptionsForMake(section, form) {
    var makeField = form.querySelector("[data-field-car-make]");
    var modelField = form.querySelector("[data-field-car-model]");
    if (!makeField || !modelField) return;

    var modelListId = modelField.getAttribute("list");
    var modelList = modelListId ? form.querySelector("#" + modelListId) : null;
    if (!modelList) return;

    var makeKey = (makeField.value || "").trim().toLowerCase();
    var mappedModels = section.__makeModelMap && section.__makeModelMap[makeKey];
    var finalModels = (mappedModels && mappedModels.length) ? mappedModels : (section.__allModelOptions || []);
    replaceDatalistOptions(modelList, finalModels);

    if (modelField.value && finalModels.length) {
      var match = finalModels.some(function(model) {
        return model.toLowerCase() === modelField.value.trim().toLowerCase();
      });
      if (!match) {
        modelField.value = "";
      }
    }
  }

  function attachQuoteModal(section) {
    var modal = section.querySelector("[data-wheel-modal]");
    if (!modal) return;

    section.addEventListener("click", function(event) {
      var openTrigger = event.target.closest("[data-wheel-open-modal]");
      if (openTrigger) {
        var cardFromTrigger = getClosestCard(openTrigger);
        var activeCard = cardFromTrigger || section.querySelector("[data-wheel-card].is-selected") || section.querySelector("[data-wheel-card]");
        if (activeCard) setSelectedCard(section, activeCard);
        setMessage(section, "");
        setContactPanelState(section, true);
        setVehiclePanelState(section, false);
        section.__contactAutoAdvanced = false;
        setModalState(section, true);
        return;
      }

      var closeTrigger = event.target.closest("[data-wheel-modal-close], [data-wheel-modal-backdrop]");
      if (!closeTrigger) return;
      setModalState(section, false);
    });

    document.addEventListener("keydown", function(event) {
      if (event.key !== "Escape") return;
      if (modal.hidden) return;
      setModalState(section, false);
    });
  }

  function setMessage(section, type) {
    var ok = section.querySelector("[data-quote-success]");
    var error = section.querySelector("[data-quote-error]");
    if (ok) ok.hidden = type !== "success";
    if (error) error.hidden = type !== "error";
  }

  function setSubmitState(form, isSubmitting) {
    var submitButton = form.querySelector("[data-submit-button]");
    if (!submitButton) return;
    var idleLabel = submitButton.getAttribute("data-submit-label") || submitButton.textContent;
    var loadingLabel = submitButton.getAttribute("data-submit-loading-label") || "Sending request...";
    submitButton.disabled = !!isSubmitting;
    submitButton.classList.toggle("is-submitting", !!isSubmitting);
    submitButton.textContent = isSubmitting ? loadingLabel : idleLabel;
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
  }

  function isValidPhone(value) {
    var digitsOnly = (value || "").replace(/\D/g, "");
    return digitsOnly.length >= 10 && digitsOnly.length <= 15;
  }

  function isValidName(value) {
    return /^[A-Za-z][A-Za-z\s'.-]{1,}$/.test(value);
  }

  function getDatalistValues(form, listId) {
    var list = form.querySelector("#" + listId);
    if (!list) return [];
    var options = list.querySelectorAll("option");
    var values = [];
    options.forEach(function(option) {
      values.push((option.value || "").trim().toLowerCase());
    });
    return values;
  }

  function valueInList(value, values) {
    return values.indexOf((value || "").trim().toLowerCase()) !== -1;
  }

  function validateVehicleFields(form) {
    var wheelSizeField = form.querySelector("[data-field-wheel-size]");
    var carYearField = form.querySelector("[data-field-car-year]");
    var carMakeField = form.querySelector("[data-field-car-make]");
    var carModelField = form.querySelector("[data-field-car-model]");
    if (!wheelSizeField || !carYearField || !carMakeField || !carModelField) {
      return form.reportValidity();
    }

    var wheelSize = wheelSizeField.value.trim();
    var carYear = carYearField.value.trim();
    var carMake = carMakeField.value.trim();
    var carModel = carModelField.value.trim();
    var yearOptions = getDatalistValues(form, carYearField.getAttribute("list"));
    var makeOptions = getDatalistValues(form, carMakeField.getAttribute("list"));
    var modelOptions = getDatalistValues(form, carModelField.getAttribute("list"));

    wheelSizeField.setCustomValidity(wheelSize ? "" : "Please select a wheel size.");
    carYearField.setCustomValidity(valueInList(carYear, yearOptions) ? "" : "Please select a valid car year from the dropdown.");
    carMakeField.setCustomValidity(valueInList(carMake, makeOptions) ? "" : "Please select a valid car make from the dropdown.");
    carModelField.setCustomValidity(valueInList(carModel, modelOptions) ? "" : "Please select a valid car model from the dropdown.");

    var orderedFields = [wheelSizeField, carYearField, carMakeField, carModelField];
    orderedFields.forEach(function(field) {
      field.classList.toggle("is-invalid", !field.checkValidity());
    });

    var valid = form.reportValidity();
    if (!valid) {
      var firstInvalid = null;
      for (var i = 0; i < orderedFields.length; i += 1) {
        if (!orderedFields[i].checkValidity()) {
          firstInvalid = orderedFields[i];
          break;
        }
      }
      if (firstInvalid) {
        setTimeout(function() {
          firstInvalid.focus({ preventScroll: true });
          firstInvalid.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
        }, 40);
      }
    }

    return valid;
  }

  function validateContactFields(form) {
    var nameField = form.querySelector("[data-field-name]");
    var emailField = form.querySelector("[data-field-email]");
    var phoneField = form.querySelector("[data-field-phone]");
    if (!nameField || !emailField || !phoneField) {
      return form.reportValidity();
    }

    var name = nameField.value.trim();
    var email = emailField.value.trim();
    var phone = phoneField.value.trim();
    nameField.setCustomValidity(isValidName(name) ? "" : "Please enter a valid name.");
    emailField.setCustomValidity(isValidEmail(email) ? "" : "Please enter a valid email address.");
    phoneField.setCustomValidity(isValidPhone(phone) ? "" : "Please enter a valid phone number.");

    var orderedFields = [nameField, emailField, phoneField];
    orderedFields.forEach(function(field) {
      field.classList.toggle("is-invalid", !field.checkValidity());
    });

    var valid = form.reportValidity();
    if (!valid) {
      var firstInvalid = null;
      for (var i = 0; i < orderedFields.length; i += 1) {
        if (!orderedFields[i].checkValidity()) {
          firstInvalid = orderedFields[i];
          break;
        }
      }
      if (firstInvalid) {
        setTimeout(function() {
          firstInvalid.focus({ preventScroll: true });
          firstInvalid.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
        }, 40);
      }
    }
    return valid;
  }

  function isContactStepComplete(form) {
    var nameField = form.querySelector("[data-field-name]");
    var emailField = form.querySelector("[data-field-email]");
    var phoneField = form.querySelector("[data-field-phone]");
    if (!nameField || !emailField || !phoneField) return false;

    var name = nameField.value.trim();
    var email = emailField.value.trim();
    var phone = phoneField.value.trim();
    return isValidName(name) && isValidEmail(email) && isValidPhone(phone);
  }

  function maybeAutoAdvanceToVehicle(section, form) {
    if (section.__contactAutoAdvanced) return;
    var contactToggle = section.querySelector("[data-contact-toggle]");
    var vehicleToggle = section.querySelector("[data-vehicle-toggle]");
    if (!contactToggle || !vehicleToggle) return;

    var contactExpanded = contactToggle.getAttribute("aria-expanded") === "true";
    var vehicleExpanded = vehicleToggle.getAttribute("aria-expanded") === "true";
    if (!contactExpanded || vehicleExpanded) return;
    if (!isContactStepComplete(form)) return;

    section.__contactAutoAdvanced = true;
    setContactPanelState(section, false);
    setVehiclePanelState(section, true);
    var yearField = form.querySelector("[data-field-car-year]");
    if (yearField) yearField.focus({ preventScroll: true });
  }

  function validateQuoteForm(form) {
    var section = form.closest("[data-wheel-explorer]");
    var vehicleValid = validateVehicleFields(form);
    if (!vehicleValid && section) setVehiclePanelState(section, true);
    var contactValid = validateContactFields(form);
    if (!contactValid && section) setContactPanelState(section, true);
    return vehicleValid && contactValid;
  }

  function attachLiveFieldValidation(form) {
    var fields = form.querySelectorAll("[data-field-wheel-size], [data-field-car-year], [data-field-car-make], [data-field-car-model], [data-field-name], [data-field-email], [data-field-phone]");
    fields.forEach(function(field) {
      field.addEventListener("input", function() {
        field.setCustomValidity("");
        field.classList.remove("is-invalid");
      });
      field.addEventListener("change", function() {
        field.setCustomValidity("");
        field.classList.remove("is-invalid");
      });
    });
  }

  function isFieldValueInList(form, field) {
    if (!field) return false;
    var listId = field.getAttribute("list");
    if (!listId) return !!field.value.trim();
    var values = getDatalistValues(form, listId);
    return valueInList(field.value, values);
  }

  function attachMobileVehicleFieldFlow(section, form) {
    var isMobile = window.matchMedia && window.matchMedia("(max-width: 749px)").matches;
    if (!isMobile) return;

    var carYearField = form.querySelector("[data-field-car-year]");
    var carMakeField = form.querySelector("[data-field-car-make]");
    var carModelField = form.querySelector("[data-field-car-model]");
    var wheelSizeField = form.querySelector("[data-field-wheel-size]");
    var submitButton = form.querySelector("[data-submit-button]");
    var moveLocks = { year: false, make: false, model: false };

    function moveTo(nextField) {
      if (!nextField) return;
      nextField.focus({ preventScroll: true });
      nextField.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    }

    function matchedListValue(field) {
      if (!field) return "";
      var listId = field.getAttribute("list");
      if (!listId) return "";
      var values = getDatalistValues(form, listId);
      var raw = (field.value || "").trim().toLowerCase();
      if (!raw) return "";
      for (var i = 0; i < values.length; i += 1) {
        if (values[i] === raw) return values[i];
      }
      return "";
    }

    function bindAutoAdvance(field, validator, nextField, afterValid, lockKey) {
      if (!field) return;
      var timer = null;

      function tryAdvance() {
        if (lockKey && moveLocks[lockKey]) return;
        if (!validator()) return;
        if (lockKey) moveLocks[lockKey] = true;
        if (typeof afterValid === "function") afterValid();
        window.setTimeout(function() {
          moveTo(nextField);
          if (lockKey) {
            window.setTimeout(function() { moveLocks[lockKey] = false; }, 150);
          }
        }, 80);
      }

      function scheduleTryAdvance() {
        window.clearTimeout(timer);
        timer = window.setTimeout(tryAdvance, 120);
      }

      field.addEventListener("change", tryAdvance);
      field.addEventListener("blur", scheduleTryAdvance);
      field.addEventListener("input", scheduleTryAdvance);
      field.addEventListener("keydown", function(event) {
        if (event.key !== "Enter") return;
        event.preventDefault();
        tryAdvance();
      });
    }

    bindAutoAdvance(carYearField, function() {
      return isFieldValueInList(form, carYearField) || !!matchedListValue(carYearField);
    }, carMakeField, null, "year");

    bindAutoAdvance(carMakeField, function() {
      return isFieldValueInList(form, carMakeField) || !!matchedListValue(carMakeField);
    }, carModelField, function() {
      updateModelOptionsForMake(section, form);
    }, "make");

    bindAutoAdvance(carModelField, function() {
      return isFieldValueInList(form, carModelField) || !!matchedListValue(carModelField);
    }, wheelSizeField, null, "model");

    if (wheelSizeField) {
      wheelSizeField.addEventListener("change", function() {
        if (!wheelSizeField.value) return;
        if (submitButton) moveTo(submitButton);
      });
    }
  }

  function attachQuoteSubmit(section) {
    var form = section.querySelector(".wheel-explorer__form");
    if (!form) return;
    attachLiveFieldValidation(form);

    var makeField = form.querySelector("[data-field-car-make]");
    if (makeField) {
      makeField.addEventListener("input", function() {
        updateModelOptionsForMake(section, form);
      });
      makeField.addEventListener("change", function() {
        updateModelOptionsForMake(section, form);
      });
    }

    attachMobileVehicleFieldFlow(section, form);

    var nameField = form.querySelector("[data-field-name]");
    var emailField = form.querySelector("[data-field-email]");
    var phoneField = form.querySelector("[data-field-phone]");
    [nameField, emailField, phoneField].forEach(function(field) {
      if (!field) return;
      field.addEventListener("blur", function() {
        maybeAutoAdvanceToVehicle(section, form);
      });
      field.addEventListener("change", function() {
        maybeAutoAdvanceToVehicle(section, form);
      });
    });

    form.addEventListener("submit", function(event) {
      event.preventDefault();
      setMessage(section, "");
      setSubmitState(form, false);

      if (!validateQuoteForm(form)) return;

      var name = form.querySelector("[data-field-name]").value.trim();
      var email = form.querySelector("[data-field-email]").value.trim();
      var phone = form.querySelector("[data-field-phone]").value.trim();
      var wheelSize = form.querySelector("[data-field-wheel-size]").value.trim();
      var carYear = form.querySelector("[data-field-car-year]").value.trim();
      var carMake = form.querySelector("[data-field-car-make]").value.trim();
      var carModel = form.querySelector("[data-field-car-model]").value.trim();
      var brand = (form.querySelector("[data-selected-brand]") || {}).value || "";
      var model = (form.querySelector("[data-selected-model]") || {}).value || "";
      var type = (form.querySelector("[data-selected-type]") || {}).value || "";
      var part = (form.querySelector("[data-selected-part]") || {}).value || "";

      var body = [
        "Quote source: Wheel Explorer",
        "Selected brand: " + brand,
        "Selected model: " + model,
        "Selected part number: " + part,
        "Wheel type: " + type,
        "Wheel size: " + wheelSize,
        "Car year: " + carYear,
        "Car make: " + carMake,
        "Car model: " + carModel,
        "Name: " + name,
        "Email: " + email,
        "Phone: " + phone
      ].join("\n");
      var bodyField = form.querySelector("[data-field-contact-body]");
      if (bodyField) bodyField.value = body;

      setSubmitState(form, true);
      fetch(form.getAttribute("action") || "/contact", {
        method: "POST",
        body: new FormData(form),
        credentials: "same-origin"
      }).then(function(response) {
        if (!response.ok) throw new Error("Request failed: " + response.status);
        setMessage(section, "success");
        form.reset();
        setSubmitState(form, false);
        section.__contactAutoAdvanced = false;
        setContactPanelState(section, true);
        setVehiclePanelState(section, false);
        var activeCard = section.querySelector("[data-wheel-card].is-selected") || section.querySelector("[data-wheel-card]");
        if (activeCard) setSelectedCard(section, activeCard);
        setModalState(section, false);
        var successEl = section.querySelector("[data-quote-success]");
        if (successEl) {
          successEl.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });
        }
      }).catch(function() {
        setSubmitState(form, false);
        setMessage(section, "error");
      });
    });
  }

  function initSection(section) {
    if (!section || section.dataset.wheelExplorerInit === "true") return;
    section.dataset.wheelExplorerInit = "true";

    attachSelection(section);
    attachBrandTabsScroller(section);
    attachCarousel(section);
    attachVehicleAccordion(section);
    attachContactAccordion(section);
    attachQuoteModal(section);

    var mapRaw = section.getAttribute("data-vehicle-make-model-map") || "";
    section.__makeModelMap = parseMakeModelMap(mapRaw);

    var modelList = section.querySelector("[data-field-car-model]");
    if (modelList) {
      var modelListId = modelList.getAttribute("list");
      var modelListElement = modelListId ? section.querySelector("#" + modelListId) : null;
      section.__allModelOptions = modelListElement ? Array.prototype.slice.call(modelListElement.querySelectorAll("option")).map(function(option) {
        return option.value;
      }) : [];
    }

    attachQuoteSubmit(section);

    var firstTab = section.querySelector("[data-wheel-brand-tab]");
    if (firstTab) {
      setActiveBrand(section, firstTab.dataset.brand || "");
    } else {
      var firstCard = section.querySelector("[data-wheel-card]");
      if (firstCard) setSelectedCard(section, firstCard);
    }
  }

  function initAll() {
    document.querySelectorAll("[data-wheel-explorer]").forEach(initSection);
  }

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", function(event) {
    var section = event.target && event.target.querySelector("[data-wheel-explorer]");
    if (section) initSection(section);
  });
})();
